export enum DocIssueType {
  None = 0,
  UnsupportedFileType = 1,
  FailedToConvertToPdf = 2,
  FailedToUploadOriginal = 4,
  FailedToIndex = 8,
  FailedToExtractContainerFile = 16,
  FailedToRedactPdf = 32,
  IsPlaceholder = UnsupportedFileType | FailedToConvertToPdf | FailedToUploadOriginal
}

export class DocIssueTypeExtension {
  static getIssueDisplayString(placeholder: DocIssueType): string {
    let placeholderString = '';

    if (placeholder & DocIssueType.UnsupportedFileType)
      placeholderString = 'Unsupported File Type';
    else if (placeholder & DocIssueType.FailedToConvertToPdf)
      placeholderString = 'Failed to Convert to PDF';
    else if (placeholder & DocIssueType.FailedToUploadOriginal)
      placeholderString = 'Failed to Upload Original';

    return placeholderString;
  }
}
